import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  Spinner,
  CardHeader,
} from "reactstrap";
import ContestFans from "./ContestFans";
import ContestAthletes from "./ContestAthletes";
import ContestSchools from "./ContestSchools";
import { useDispatch, useSelector } from "react-redux";
import { fetchContestOrganizer } from "store/actions/contestAction";

const ContestDetails = ({ showModal, handleModalToggle, contestId }) => {
  const dispatch = useDispatch();
  const { contestOrganizer } = useSelector((state) => state.contest);

  const [activeTab, setActiveTab] = useState("schools");
  const [isLoading, setIsLoading] = useState(false);

  const tabs = [
    {
      id: "schools",
      name: "Schools",
      content: <ContestSchools contestId={contestId} />,
    },
    {
      id: "athletes",
      name: "Athletes",
      content: <ContestAthletes contestId={contestId} />,
    },
    {
      id: "fans",
      name: "Fans",
      content: <ContestFans contestId={contestId} />,
    },
  ];

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  useEffect(() => {
    if (!showModal) {
      setActiveTab(tabs[0]?.id);
    } else {
      setIsLoading(true);
      dispatch(fetchContestOrganizer({ contestId })).finally(() =>
        setIsLoading(false)
      );
    }
  }, [showModal]);

  return (
    <Modal isOpen={showModal} centered toggle={handleModalToggle} size="xl">
      <ModalHeader closeButton>Contest Details</ModalHeader>
      {isLoading ? (
        <div className="text-center py-6">
          <Spinner color="primary" />
        </div>
      ) : (
        <>
          {contestOrganizer && (
            <div className="px-4 pt-2">
              <h3 className="text-underline">Contest Organizer</h3>
              <div className="d-flex align-items-center">
                <h4 className="mb-0 mr-2" style={{ opacity: 0.8 }}>
                  Name:
                </h4>
                <p style={{ fontWeight: 500 }} className="mb-0">
                  {contestOrganizer?.name}
                </p>
              </div>
              <div className="d-flex align-items-center">
                <h4 className="mb-0 mr-2" style={{ opacity: 0.8 }}>
                  Email:
                </h4>
                <p style={{ fontWeight: 500 }} className="mb-0">
                  {contestOrganizer?.email}
                </p>
              </div>
            </div>
          )}
          <ModalBody>
            <Card
              className="overflow-hidden"
              style={{ boxShadow: "1px 1.5px 2px rgba(0, 0, 0, 0.05)" }}
            >
              <CardHeader
                className="border-0 d-flex align-items-center p-0"
                style={{
                  overflowX: "auto",
                  WebkitOverflowScrolling: "touch",
                  scrollbarWidth: "none",
                }}
              >
                {tabs.map((tab) => (
                  <div
                    key={tab.id}
                    className="mb-0 px-3 px-sm-4 py-3 pointer text-nowrap"
                    style={{
                      borderBottom: activeTab === tab.id && "3px solid #5E72E4",
                      fontWeight: activeTab === tab.id && "600",
                    }}
                    onClick={() => handleTabChange(tab.id)}
                  >
                    {tab.name}
                  </div>
                ))}
              </CardHeader>
              <div>{tabs.find((tab) => tab.id === activeTab)?.content}</div>
            </Card>
          </ModalBody>
        </>
      )}
      <ModalFooter>
        <Button color="danger" onClick={handleModalToggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ContestDetails;
